// Imports
import React, { Fragment } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate } from 'react-router-dom';

// Views
import RoutesMainView from "../../modules/routes/views/main"
import { HasPermission } from "Core/security";

// Router
const RouterRoutesViews = (props) => {
  const { match } = props;
  const user = useSelector((state) => state.securityRedux.user);

  return (
    <Routes>
      {
        HasPermission(user, ['dapprta'], [250]) && (
          <Fragment>
            <Route path='/' element={<Navigate to="/app/routes/main" />}></Route>
            <Route path='main' element={<RoutesMainView />} />
          </Fragment>
        )
      }
      <Route path="*" element={<Navigate to="/app/error" />} />
    </Routes>
  );
};

export default RouterRoutesViews;
